import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { providers } from "@/mocks/ppcare";

export default function ProvidersSection() {
  return (
    <section id="providers" className="bg-background-100 py-16 md:py-24">
      <div className="container">
        <Reveal>
          <SectionHeading
            eyebrow="Meet Our Doctors"
            title={
              <>
                Our Providers at Personal Physician{" "}
                <span className="text-accent-500">Care</span>
              </>
            }
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {providers.map((provider, index) => (
            <Reveal key={`${provider.firstName}-${provider.lastName}`} delay={(index % 4) * 70}>
              <div className="flex h-full flex-col items-center rounded-lg border border-background-200 bg-background-50 p-6 text-center transition-colors hover:border-primary-200">
                <div className="flex h-36 w-36 items-center justify-center overflow-hidden rounded-full border-4 border-primary-100 bg-primary-50 p-2">
                  <img
                    src={provider.image}
                    alt={`${provider.firstName} ${provider.lastName}`}
                    className="h-full w-full object-contain object-bottom"
                  />
                </div>
                <div className="mt-5">
                  <h3 className="text-base font-semibold leading-snug text-foreground-900">
                    {provider.firstName}
                  </h3>
                  <h3 className="text-base font-bold leading-snug text-foreground-950">
                    {provider.lastName}
                  </h3>
                </div>
                <p className="mt-1 font-label text-xs uppercase tracking-widest text-accent-600">
                  {provider.credential}
                </p>
                <a
                  href={provider.href}
                  className="mt-5 inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-primary-500 px-5 py-2 text-sm font-semibold text-primary-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  Learn More
                </a>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <a
            href="#providers"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-8 py-4 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            View All Providers
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}